// Presentation-only tokens. Import these without pulling in API/native config.
export const DEFAULT_FONT_FAMILY = 'ui-sans-serif,-apple-system, system-ui, -apple-system, BlinkMacSystemFont, Roboto, Ubuntu, "Open Sans", Arial, "Helvetica Neue", Segoe UI Emoji, Segoe UI Symbol, sans-serif';
export const BORDER_RADIUS = { small: 6, medium: 12, large: 16, round: 9999 };
